module.exports = __webpack_public_path__ + "static/media/worship.94389339.svg";